import React from "react";
import s from "./Footer.module.scss";

export default function Footer() {
  return (
    <footer className={s.footer}>
      ПО ВОПРОСАМ РЕКЛАМЫ И ПАРТНЕРСТВА:
      <a className={s.mail} href="mailto:nomercyradio@gmail.com">
        NOMERCYRADIO@GMAIL.COM
      </a>
    </footer>
  );
}
